import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useEntity } from '../../contexts/EntityContext';
import DataSourceSetup from '../../components/DataIngestion/DataSourceSetup';
import './DataIngestionPage.css';

function DataIngestionPage() {
  const { currentEntity } = useEntity();
  const [activeTab, setActiveTab] = useState('setup'); // 'setup', 'sources', 'history'
  useEffect(() => { document.title = 'PEC - Ingesta de Datos'; }, []);

  return (
    <div className="data-ingestion-page">
      <Header currentPage="data-ingestion" />

      <div className="ingestion-content">
        {!currentEntity && (
          <div className="entity-warning">
            <span className="warning-icon">⚠️</span>
            <div>
              <strong>Entity Required</strong>
              <p>Please select an entity from the sidebar to set up data ingestion.</p>
            </div>
          </div>
        )}

        <div className="ingestion-tabs">
          <button 
            className={`tab ${activeTab === 'setup' ? 'active' : ''}`}
            onClick={() => setActiveTab('setup')}
          >
            🔗 Setup New Source
          </button>
          <button 
            className={`tab ${activeTab === 'sources' ? 'active' : ''}`}
            onClick={() => setActiveTab('sources')}
          >
            📋 Active Sources
          </button>
          <button 
            className={`tab ${activeTab === 'history' ? 'active' : ''}`}
            onClick={() => setActiveTab('history')}
          >
            📈 Ingestion History
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'setup' && (
            <div className="setup-tab">
              {currentEntity ? (
                <DataSourceSetup />
              ) : (
                <div className="setup-disabled">
                  <span className="disabled-icon">🔒</span>
                  <h3>Entity Selection Required</h3>
                  <p>Please select an entity to configure data sources for that specific entity.</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'sources' && (
            <div className="sources-tab">
              <div className="sources-header">
                <h2>📋 Active Data Sources</h2>
                <p>Manage your configured data sources and workflows</p>
              </div>

              {currentEntity ? (
                <div className="sources-list">
                  <div className="empty-sources">
                    <span className="empty-icon">📊</span>
                    <h3>No Data Sources Configured</h3>
                    <p>You haven't set up any data sources for <strong>{currentEntity.name}</strong> yet.</p>
                    <button 
                      className="btn-primary"
                      onClick={() => setActiveTab('setup')}
                    >
                      🔗 Set Up First Data Source
                    </button>
                  </div>
                </div>
              ) : (
                <div className="entity-required">
                  <span className="required-icon">🏢</span>
                  <h3>Entity Selection Required</h3>
                  <p>Select an entity to view its configured data sources.</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'history' && (
            <div className="history-tab">
              <div className="history-header">
                <h2>📈 Data Ingestion History</h2>
                <p>View the history of data synchronization activities</p>
              </div>

              {currentEntity ? (
                <div className="history-list">
                  <div className="empty-history">
                    <span className="empty-icon">📊</span>
                    <h3>No Ingestion History</h3>
                    <p>Once you set up data sources, their synchronization history will appear here.</p>
                  </div>
                </div>
              ) : (
                <div className="entity-required">
                  <span className="required-icon">🏢</span>
                  <h3>Entity Selection Required</h3>
                  <p>Select an entity to view its data ingestion history.</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Quick Stats */}
        <div className="quick-stats">
          <div className="stats-header">
            <h2>📊 Pipeline Overview</h2>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">🔗</div>
              <div className="stat-content">
                <h3>0</h3>
                <p>Active Sources</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⚡</div>
              <div className="stat-content">
                <h3>0</h3>
                <p>Running Workflows</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📊</div>
              <div className="stat-content">
                <h3>0</h3>
                <p>Records Synced</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-content">
                <h3>0%</h3>
                <p>Success Rate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataIngestionPage; 